import { IInputValue } from './common.domain';

export const SHIPPING_OPTION_DEFAULT = 'Ground';
export const SHIPPING_OPTION_UNAVAILABLE = 'Unavailable';

export interface IShippingInformation {
  shippingMethod: IInputValue<string | null>;
  timeRestriction: IInputValue<string>;
}
